<template>
    <div class="Offer" ref="oneBlock">
        <div class="Offer__in">
            <strong v-html="params?.title"></strong>
            <p v-html="params?.text"></p>
            <div class="Offer__actions" v-if="showBtns">
              <template v-for="(btn,key) in params?.action">
                <ABtn v-if="key!='text'"
                      :label="btn.title"
                      :class="key=='confirm'?'primary':'flat outlined'"
                      :color="key=='confirm'?'':'var(--c-primary-200)'"
                      @click.native="clckFunction(btn)"
                />
                <div v-else>
                  {{btn}}
                </div>
              </template>

            </div>
        </div>
    </div>
</template>

<script>
import {ABtn, useAProgressBar} from "../ui";
import {send} from "../../services/api";
import {onMounted, ref} from "vue";
export default {
    name: "Offer",
    props:['params','id',"watched"],
    emits:['watched'],
    components: {
        ABtn
    },
    setup(props, ctx) {
      const progress = useAProgressBar();
      const showBtns = ref(true);
      const oneBlock = ref(null);
      const sended = ref(props.watched);
      const clckFunction = async (btn) => {
        progress.show();
        await send(btn.link, {method: "post"}, btn.data).then((response) => {
          if(response.hideBtns) {
            showBtns.value = false;
          }
          progress.hide();
        });
      }
      onMounted(() => {
          if(!sended.value) {
              if (testVisibleBlock(oneBlock.value)) {
                  ctx.emit('watched', props.id);
                  sended.value = true;
              }
              window.addEventListener('scroll', function () {
                  if (testVisibleBlock(oneBlock.value)&&!sended.value) {
                      ctx.emit('watched', props.id);
                      sended.value = true;
                  }
              });
              let parentWithClass = oneBlock.value.closest('.ChatWindow__in');
              parentWithClass.addEventListener('scroll', function () {
                  if (testVisibleBlock(oneBlock.value)&&!sended.value) {
                      ctx.emit('watched', props.id);
                      sended.value = true;
                  }
              });
          }
      });



      return {
        clckFunction,
        oneBlock,
        showBtns
      }
    }
}
</script>

<style scoped lang="scss">
.Offer {
    display: flex;
    justify-content: center;
    padding: rem(36) rem(15);
    border: 1px solid var(--c-gray-700);
    border-radius: rem(6);
    background-color: #fff;
    margin-bottom: rem(10);

    &__in {
        max-width: rem(395);
        display: flex;
        align-content: center;
        text-align: center;
        flex-direction: column;
    }

    strong {
        margin-bottom: rem(7);
        display: block;
    }

    p {
        margin-bottom: 0;
    }

    &__actions {
        display: flex;
        gap: rem(13);
        padding: rem(20);
        justify-content: center;
    }
}
</style>